import * as React from 'react';

import { injectTags } from 'common/js/inject-tags';
import eventBus from 'common/event-handling/event-bus.model';
import { PreloadedEvent } from 'common/event-handling/events';
interface Props {
  code: string;
  containerSelector: string;
}

export default class TagInject extends React.PureComponent<Props> {
  componentDidMount() {
    const { code, containerSelector } = this.props;

    injectTags(code, containerSelector, containerSelector, 'body', {
      overloadDocumentWrite: true,
      enableSentryLog: true,
      allowInjectIntoBody: true
    });

    eventBus.publish(new PreloadedEvent());
  }

  render() {
    return null;
  }
}
